import { SimpleError } from 'models/error';

export const getErrorMessage = (error: any): string => {
  console.error(error);
  const serialError = error as SimpleError;
  const errorMessage = serialError?.data?.error;
  const errorData = serialError?.data?.errorData;
  const errorCode = serialError?.data?.code;

  const errorStatus = serialError?.data?.status;
  const errorMessageValidation = serialError?.data?.message;

  if (errorMessageValidation) return errorMessageValidation;

  switch (errorMessage) {
    case 'USER_ALREADY_EXISTS':
      return 'Пользователь с таким логином/email уже существует';
    case 'TEAM_ALREADY_EXISTS':
      return 'Команда с таким именем уже существует';
    case 'NOT_ENOUGH_PRODUCT':
      return 'Не достаточно продукта в наличии';
    case 'FIND_DUBLICATES':
      return `Были найдены дубликаты  - ${errorData ? errorData.join(' ') : ''}`;
    case 'REJECTED_PRODUCTS':
      return `Не были загружены - ${errorData ? errorData.join(' ') : ''}`;
    case 'PRODUCT_TYPE_NOT_EXIST':
      return `Тип продукта не найден`;
    case 'ORDER_NOT_FOUND':
      return `Заказ не найден`;
    case 'LOGIN_ALREADY_EXIST':
      return `Такой логин уже существует`;
    case 'PRODUCT_NOT_EXIST':
      return `Продукт не найден`;
    case 'PRODUCT_ALREADY_EXIST':
      return `Такой продукт уже существует`;
    case 'CATEGORY_NOT_EXIST':
      return `Категория продукта не найдена`;
    case 'PRODUCT_TYPE_NAME_ALREADY_EXIST':
      return `Тип продукта уже существует`;
    case 'PERSON_NOT_EXIST':
      return `Персонаж не найден`;
    case 'PERMISSION_ALREADY_EXIST':
      return `Такое разрешение уже существует`;
    case 'AFFILIATE_NOT_EXIST':
      return `Такой пп не существует`;
    case 'PERMISSION_NOT_EXIST':
      return `Разрешение не найдено`;
    case 'UPLOAD_ERROR':
      return `Ошибка при загрузке фото`;
    case 'FORBIDDEN_TYPE':
      return `Запрещенный тип файла`;
    case 'OFFER_ALREADY_EXIST':
      return `Такой оффер уже существует`;
    case 'AFFILIATE_NOT_FOUND':
      return 'Парнерская программа не найдена';
    case 'TRACKER_ALREADY_EXIST':
      return 'Такой трекер уже существует';
    case 'ACCOUNT_ALREADY_EXIST':
      return 'Такой аккаунт уже существует';
    case 'PERMISSIONS_ERROR':
      return 'Нет доступа';
    case 'PAYMENT_CREDENTIAL_ID_NOT_FOUND':
      return 'Платёжная информация не найдена';
    case 'CUSTOM_RULE_NOT_FOUND':
      return 'Автоправило не найдено';
    case 'RULES_NOT_FOUND':
      return 'Группа не найдена';
    case 'PROXY_STILL_USING':
      return 'Прокси ещё используется';
    case 'PROXY_ALREADY_EXISTS':
      return 'Такой прокси уже существует';
    case 'NO_DOMAINS':
      return 'Нет доменов';
    case 'ERROR':
      return 'Ошибка';
    case 'CARD_NOT_FOUND':
      return 'Карта не найдена';
    case 'KEITARO_ERROR':
      return `Ошибка кейтаро - ${errorData ? JSON.stringify(errorData) : ''}`;
    case 'VACATION_ALREADY_EXISTS':
      return 'Сотрудник уже находится в отпуске в один из выбранных дней';
    case 'MAX_VACATION_DAYS_EXCEEDED':
      return 'Слишком большой период отпуска';
    default:
      break;
  }

  switch (errorCode) {
    case 'LIMIT_FILE_SIZE':
      return `Вес не должен превышать 5 МБ`;
    default:
      break;
  }

  switch (errorStatus) {
    case 403:
      return 'У вас нет прав';

    default:
      break;
  }

  return errorMessage || 'Неизвестная ошибка';
};
